import { render, staticRenderFns } from "./RequestQc.vue?vue&type=template&id=54f81f70&"
import script from "./RequestQc.vue?vue&type=script&lang=js&"
export * from "./RequestQc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports